module.exports = __webpack_public_path__ + "media/fonts/Oricons-a3a3c6b9167998bf808ca017b1cd1ecc.svg";